import axiosInstance from '../../services/axiosInstance';
import { Issue, Task } from './types';

export interface IssueReorderItem {
  id: string;
  status: string;
  boardOrder: number;
}

export interface TaskReorderItem {
  id: string;
  status: string;
  boardOrder: number;
}

export const fetchIssues = async (params?: Record<string, any>): Promise<Issue[]> => {
  const { data } = await axiosInstance.get('/api/issues', { params });
  return data;
};

export const fetchTasks = async (params?: Record<string, any>): Promise<Task[]> => {
  const { data } = await axiosInstance.get('/api/tasks', { params });
  return data;
};

export const createIssue = async (payload: Record<string, any>, files: File[] = []): Promise<Issue> => {
  const formData = new FormData();
  Object.entries(payload || {}).forEach(([key, value]) => {
    if (value === undefined || value === null) return;
    formData.append(key, String(value));
  });
  files.forEach((file) => formData.append('attachments', file));
  const { data } = await axiosInstance.post('/api/issues', formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
  return data;
};

export const updateIssue = async (id: string, payload: Record<string, any>): Promise<Issue> => {
  const { data } = await axiosInstance.patch(`/api/issues/${id}`, payload);
  return data;
};

export const deleteIssue = async (id: string): Promise<void> => {
  await axiosInstance.delete(`/api/issues/${id}`);
};

export const reorderIssues = async (items: IssueReorderItem[]): Promise<void> => {
  await axiosInstance.post('/api/issues/reorder', { items });
};

export const addIssueAttachments = async (issueId: string, files: File[]): Promise<void> => {
  if (!files.length) return;
  const formData = new FormData();
  files.forEach((file) => formData.append('attachments', file));
  await axiosInstance.post(`/api/issues/${issueId}/attachments`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
};

export const deleteIssueAttachment = async (issueId: string, attachmentId: string): Promise<void> => {
  await axiosInstance.delete(`/api/issues/${issueId}/attachments/${attachmentId}`);
};

export const downloadIssueAttachment = async (issueId: string, attachmentId: string): Promise<Blob> => {
  const response = await axiosInstance.get(`/api/issues/${issueId}/attachments/${attachmentId}`, {
    responseType: 'blob'
  });
  return response.data;
};

export const createTask = async (payload: Record<string, any>): Promise<Task> => {
  const { data } = await axiosInstance.post('/api/tasks', payload);
  return data;
};

export const updateTask = async (id: string, payload: Record<string, any>): Promise<Task> => {
  const { data } = await axiosInstance.patch(`/api/tasks/${id}`, payload);
  return data;
};

export const deleteTask = async (id: string): Promise<void> => {
  await axiosInstance.delete(`/api/tasks/${id}`);
};

export const reorderTasks = async (items: TaskReorderItem[]): Promise<void> => {
  await axiosInstance.post('/api/tasks/reorder', { items });
};

export const fetchTaskAssignees = async (): Promise<string[]> => {
  const { data } = await axiosInstance.get('/api/tasks/assignees');
  return data;
};
